import { render } from "./BoschIdFaq.vue?vue&type=template&id=48ff0b06&scoped=true"
import script from "./BoschIdFaq.vue?vue&type=script&lang=js"
export * from "./BoschIdFaq.vue?vue&type=script&lang=js"

import "./BoschIdFaq.vue?vue&type=style&index=0&id=48ff0b06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ff0b06"]])

export default __exports__